import { createSlice } from "@reduxjs/toolkit";
import {
  fetchTeacherSubscription,
  updateTeacherSubscriptionStatus,
} from "./operation.js";

const teacherSubscriptionSlice = createSlice({
  name: "teacherSubscription",
  initialState: {
    data: null,
    loading: false,
    error: null,
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchTeacherSubscription.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchTeacherSubscription.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchTeacherSubscription.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(updateTeacherSubscriptionStatus.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateTeacherSubscriptionStatus.fulfilled, (state, action) => {
        state.loading = false;
        state.subscription = action.payload;
      })
      .addCase(updateTeacherSubscriptionStatus.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default teacherSubscriptionSlice.reducer;
